import { type FirebaseApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

let initialized = false;

/**
 * Initialize Firebase App Check on the client.
 * Must run before any Firebase service requests (Auth, Firestore, Storage).
 */
export function initAppCheck(app: FirebaseApp): void {
  if (initialized || typeof window === 'undefined') {
    return;
  }

  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_ENTERPRISE_SITE_KEY;
  if (!siteKey) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        'App Check not initialized: set NEXT_PUBLIC_RECAPTCHA_ENTERPRISE_SITE_KEY in .env.local'
      );
    }
    return;
  }

  if (process.env.NODE_ENV === 'development') {
    const debugToken = process.env.NEXT_PUBLIC_FIREBASE_APPCHECK_DEBUG_TOKEN;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken || true;
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(siteKey),
    isTokenAutoRefreshEnabled: true,
  });

  initialized = true;
}
